exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__wrapper___3-mgA .Top-module__dropdown___1pSI1{width:250px}.Top-module__wrapper___3-mgA .Top-module__students___2urpZ{margin-bottom:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Top-module__wrapper___3-mgA",
	"dropdown": "Top-module__dropdown___1pSI1",
	"students": "Top-module__students___2urpZ"
};